import { isArray } from "lodash";
import { fetchAutocompleteCustomValues } from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";

import { CustomTypesWithCategory } from "../hooks/use_filters";
import { VisibleCategory } from "../parts/types/types";

const normalize = (text = "") => text.toLowerCase().replace(/ /g, "");

export const getValue = (customType, selectedFilters) => selectedFilters?.strings?.[customType.name];

export const generateQueryFunction =
  (customTypeName, currentProfile) =>
  ({ term, value }) =>
    customTypeName !== "talent_pool"
      ? fetchAutocompleteCustomValues({ type: customTypeName, term, value, global: false })
      : Promise.resolve(
          currentProfile.talent_pool
            ?.map((t) => ({ id: t.id, text: t.value }))
            .filter((val) => normalize(val.text).indexOf(normalize(term)) !== -1)
        );

export const formatNumber = (num) => {
  if (num === undefined || isNaN(num)) {
    return "N/A";
  } else {
    return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : num;
  }
};

export const formatVisibleTiles = (
  currentData: Record<string, number> | undefined,
  storedData: VisibleCategory[]
): VisibleCategory[] => {
  const stored = formatFromStringToArray(storedData);
  if (stored && stored.length > 0) {
    return stored.map((item) => ({
      category: item.category,
      value: checkIsANumber(currentData?.[item.category]),
      visible: Boolean(item.visible)
    }));
  } else if (currentData) {
    return Object.keys(currentData).map((category) => ({
      category: category,
      value: currentData[category],
      visible: Boolean(currentData[category])
    }));
  } else {
    return [];
  }
};

export const formatFromStringToArray = (data) => (typeof data === "string" ? JSON.parse(data) : data);

export const extractCfName = (str: string): string | null => {
  const nameRegex = /pcf_\[(\w+)\]/;
  const match = str.match(nameRegex);
  if (match) {
    return match[1];
  } else {
    return str;
  }
};

export const getDemandFilterValue = (filterName, customValues, selectedFilters) => {
  const filterValue = selectedFilters[filterName.name];

  if (!filterValue || !isArray(filterValue)) {
    return null;
  }

  return filterValue.map((id) => {
    const text = customValues.find((customValue) => customValue.id === id)?.text || "";
    return { id, text };
  });
};

export const flattenRangeFilters = (selectedFilters) => ({
  ...selectedFilters,
  start_date: selectedFilters.period.value.start,
  end_date: selectedFilters.period.value.end
});

export const checkIsANumber = (data) => {
  if (isNaN(data)) {
    return "N/A";
  } else {
    return data;
  }
};

export const checkIsFilterActive = (name: string, activeFilters?: CustomTypesWithCategory[]) =>
  (activeFilters || []).some((filter) => filter.name === name);
